const categoriesData = [
  {
    name: 'Shoes',
    desc: 'Premium sneakers and footwear from top verified sellers. Every pair checked for quality.',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    color: 'bg-primary-100/80',
    imgUrl: 'https://readdy.ai/api/search-image?query=Pair%20of%20white%20and%20beige%20designer%20sneakers%20on%20cream%20marble%20surface%20with%20soft%20side%20lighting%2C%20minimalist%20luxury%20product%20photography%2C%20subtle%20reflection%2C%20neutral%20warm%20tones%2C%20clean%20editorial%20composition&width=600&height=800&seq=cat-shoe-v2-2026&orientation=portrait',
    icon: 'ri-footprint-line',
  },
  {
    name: 'Hoodies / Sweaters',
    desc: 'Cozy oversized hoodies and premium sweaters. Trendy designs, comfortable fits.',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    color: 'bg-secondary-100/80',
    imgUrl: 'https://readdy.ai/api/search-image?query=Oversized%20sand%20colored%20hoodie%20draped%20over%20wooden%20chair%20by%20sunny%20window%2C%20soft%20morning%20light%20casting%20gentle%20shadows%2C%20cozy%20aesthetic%2C%20editorial%20fashion%20photography%2C%20warm%20earthy%20tones&width=600&height=800&seq=cat-hoodie-v2-2026&orientation=portrait',
    icon: 'ri-t-shirt-line',
  },
  {
    name: 'T-Shirts',
    desc: 'Graphic tees and essential basics. Quality cotton, unique prints, great prices.',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    color: 'bg-accent-50/80',
    imgUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20cotton%20t-shirt%20neatly%20folded%20with%20visible%20texture%20on%20light%20oak%20surface%2C%20clean%20studio%20lighting%2C%20simple%20elegant%20product%20photography%2C%20neutral%20soft%20palette&width=600&height=800&seq=cat-tshirt-v2-2026&orientation=portrait',
    icon: 'ri-t-shirt-air-line',
  },
  {
    name: 'Jackets',
    desc: 'Stylish bombers, denim and winter jackets. All seasons covered with quality picks.',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    color: 'bg-primary-50/80',
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20beige%20bomber%20jacket%20hanging%20on%20minimalist%20wooden%20hanger%20against%20warm%20cream%20wall%2C%20natural%20light%20from%20left%2C%20editorial%20fashion%20catalog%20photography%2C%20sophisticated%20neutral%20aesthetic&width=600&height=800&seq=cat-jacket-v2-2026&orientation=portrait',
    icon: 'ri-t-shirt-air-line',
  },
  {
    name: 'Pants / Shorts',
    desc: 'Casual pants, cargo, denim and summer shorts. Comfort meets street style.',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    color: 'bg-secondary-50/80',
    imgUrl: 'https://readdy.ai/api/search-image?query=Stylish%20beige%20cargo%20pants%20artfully%20draped%20on%20cream%20linen%20backdrop%2C%20natural%20diffused%20lighting%2C%20editorial%20product%20photography%2C%20visible%20fabric%20texture%2C%20warm%20minimalist%20composition&width=600&height=800&seq=cat-pants-v2-2026&orientation=portrait',
    icon: 'ri-pantone-line',
  },
  {
    name: 'Bags',
    desc: 'Backpacks, totes, crossbody bags. Designer-inspired styles at affordable prices.',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    color: 'bg-accent-100/80',
    imgUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20cream%20leather%20tote%20bag%20standing%20on%20minimalist%20white%20surface%2C%20soft%20studio%20lighting%20with%20gentle%20highlights%2C%20premium%20product%20photography%2C%20clean%20elegant%20composition%2C%20warm%20neutral%20aesthetic&width=600&height=800&seq=cat-bags-v2-2026&orientation=portrait',
    icon: 'ri-handbag-line',
  },
  {
    name: 'Accessories',
    desc: 'Watches, jewelry, sunglasses and more. Complete your look with the perfect details.',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    color: 'bg-primary-100/80',
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20minimalist%20gold%20watch%20leather%20bracelet%20and%20classic%20sunglasses%20on%20cream%20surface%2C%20warm%20studio%20lighting%2C%20editorial%20accessory%20flat%20lay%2C%20sophisticated%20neutral%20palette&width=600&height=800&seq=cat-accessory-v2-2026&orientation=portrait',
    icon: 'ri-glasses-line',
  },
  {
    name: 'Headwear',
    desc: 'Caps, beanies and bucket hats. Top off your outfit with trending headwear.',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    color: 'bg-secondary-100/80',
    imgUrl: 'https://readdy.ai/api/search-image?query=Stylish%20neutral%20tone%20baseball%20cap%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%20with%20soft%20directional%20lighting%2C%20subtle%20fabric%20texture%20visible%2C%20warm%20beige%20aesthetic&width=600&height=800&seq=cat-headwear-v2-2026&orientation=portrait',
    icon: 'ri-billiards-line',
  },
];

export default function CategoryGrid() {
  return (
    <section id="categories-section" className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <p className="text-xs md:text-sm font-medium uppercase tracking-widest text-primary-600 mb-3">
              Browse by Category
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Explore Our{' '}
              <span className="font-heading italic font-normal text-primary-600">Curated Collection</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-xs">
            Every category features hand-picked items from the latest Sugargoo spreadsheet with verified seller links
          </p>
        </div>

        {/* Grid with text descriptions */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categoriesData.map((card) => (
            <a
              key={card.name}
              href={card.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-2xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              {/* Image area */}
              <div className={`relative ${card.color} aspect-[3/4] overflow-hidden`}>
                <img
                  src={card.imgUrl}
                  alt={`${card.name} - Sugargoo Spreadsheet verified products`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
              </div>

              {/* Label + Description */}
              <div className="p-4">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${card.icon} text-lg text-foreground-700`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{card.name}</h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">{card.desc}</p>
                <div className="flex items-center gap-1.5 text-primary-600 font-medium text-xs">
                  Browse Products
                  <i className="ri-arrow-right-up-line text-xs group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}